// GENERATO AUTOMATICAMENTE da scripts/generateApiDocs.js
// Non modificare manualmente - aggiornato ad ogni commit
export const API_DOCS = [
  {
    method: 'GET',
    endpoint: '/api/report-templates?societaId=',
    requestBody: null,
    response: '{"success":true,"data":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/smtp?tipo=EMAIL',
    requestBody: null,
    response: '{"smtp":[...]}'
  },
  {
    method: 'GET',
    endpoint: '/api/smtp?tipo=PEC',
    requestBody: null,
    response: '{"smtp":[...]}'
  },
  {
    method: 'PUT',
    endpoint: '/api/report-templates/:id',
    requestBody: 'FormData{nome,moduloGestionale,...}',
    response: '{"success":true}'
  },
  {
    method: 'POST',
    endpoint: '/api/report-templates',
    requestBody: 'FormData{societaId,nome,moduloGestionale,file,...}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'POST',
    endpoint: '/api/report-templates/:id/duplica',
    requestBody: '{"societaId":"number","nome":"string"}',
    response: '{"success":true,"data":{"id":"number"}}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates/importa/societa',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","numTemplate":"number"}]}'
  },
  {
    method: 'GET',
    endpoint: '/api/report-templates/importa/templates?sorgenteId=',
    requestBody: null,
    response: '{"success":true,"data":[{"id":"number","nome":"string","moduloGestionale":"string","attivo":"boolean","dimensioneHbs":"number","haSmtp":"boolean"}]}'
  },
  {
    method: 'POST',
    endpoint: '/api/report-templates/importa',
    requestBody: '{"societaId":"number","templateIds":["number"]}',
    response: '{"success":true,"data":{"importati":[...],"totale":"number"}}'
  },
  {
    method: 'PATCH',
    endpoint: '/api/report-templates/:id/toggle-attivo',
    requestBody: null,
    response: '{"success":true,"data":{"attivo":"boolean"}}'
  }
] as const;

export type ApiDoc = typeof API_DOCS[number];
